// extracted by mini-css-extract-plugin
export default {"formContainer":"Categories_formContainer__0Wrzv","list":"Categories_list__uNKcK","item":"Categories_item__uJU2q"};